import React from 'react'
// Improt Link
import { Link } from 'react-router-dom'
// import Logo
import logo from "../assets/img/logo.png"
// import Data
import { FooterData } from './FooterData'

const Footer = () => {

  return (
    <>
    <footer id="footer_area">
        <div className="container">
            <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="footer_area_about">
                        <img src={logo} alt="PCF" />
                        <p>PCF is a Pakistani cultural and sports organisation based in Sweden. We work on <strong>culture</strong>,{' '}
                            <strong>education</strong>, and <strong>integration</strong>—helping families thrive here while keeping roots strong.
                            <strong> Badminton</strong> is our main sport; we also organise seasonal swimming, cricket, football, social
                            gatherings, and integration-focused activities for children and adults.</p>
                        <h6><strong>Address:</strong> Sweden (contact us for local venue details)</h6>
                        <h6><strong>Phone:</strong> <Link to="tel:+46701234567">+46 70 123 45 67</Link></h6>
                        <h6><strong>Email:</strong> <Link to="mailto:info@pcfsweden.se">info@pcfsweden.se</Link></h6>
                    </div>
                </div>
                {FooterData.map((data, index) =>(
                      <div className="col-lg-2 col-md-6 col-sm-12 col-12" key={index}>
                      <div className="footer_navitem_ara">
                          <h3>{data.heading}</h3>
                          <div className="nav_item_footer">
                              <ul>
                                {data.item.map((datas, index1) =>(
                                    <li key={index1}><Link to={datas.linkL}>{datas.FItem}</Link></li>
                                ))}
                              </ul>
                          </div>
                      </div>
                  </div>
                ))}

                <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="footer_navitem_ara">
                        <h3>Community updates</h3>
                        <div className="footer_twitter_area">
                            <Link to="#!" className="footer_twit_title"><i className="fab fa-twitter"></i> #PCFSweden</Link>
                            <p>Follow PCF for badminton times, seasonal swim/cricket/football blocks, integration evenings, and
                                social gatherings.</p>
                            <Link to="#!" className="footer_twit_two">Social links coming soon</Link>
                            <h6>Thank you for supporting our children and families</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>

    </>
  )
}

export default Footer